'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCells = exports.getCellCombinedSeries = exports.getCellRelevantAttributes = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _getFlagsAndNotes = require('./getFlagsAndNotes');
var _hasCellMetadata = require('../hasCellMetadata');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getCellRelevantAttributes = exports.getCellRelevantAttributes = function getCellRelevantAttributes(attributes, attributesSeries, cellAttributeIds) {
  return R.filter(function (attr) {
    if (R.isNil(attr.value)) {
      return false;
    }
    if (R.has(attr.id, cellAttributeIds)) {
      return true;
    }
    var attrInSerie = R.path([attr.serieKey, attr.id], attributesSeries);
    return R.isNil(attrInSerie);
  }, attributes);
};
var getCellCombinedSeries = exports.getCellCombinedSeries = function getCellCombinedSeries(attributes, combinations) {
  return R.reduce(function (acc, comb) {
    var values = R.reduce(function (acc, concept) {
      if (R.has(concept, comb.fixedDimValues || {})) {
        return R.append(R.prop(concept, comb.fixedDimValues), acc);
      }
      if (R.has(concept, attributes || {})) {
        return R.append(R.path([concept, 'value'], attributes), acc);
      }
      return acc;
    }, [], comb.concepts);
    if (R.isEmpty(values)) {
      return acc;
    }
    return R.append((0, _extends3.default)({}, R.pick(['id', 'name'], comb), {
      values: values
    }), acc);
  }, [], combinations);
};

// combinations = { cells, layout };
var getCells = exports.getCells = function getCells(customAttributes, cellsAttributesId, combinations, attributesSeries, metadataCoordinates) {
  return function (observations) {
    var attributesInLayoutCombination = R.pipe(R.propOr([], 'layout'), R.pluck('concepts'), R.unnest)(combinations);
    var attributesInCellsCombination = R.pipe(R.propOr([], 'cells'), R.pluck('concepts'), R.unnest)(combinations);
    var _customAttributes = R.over(R.lensProp('notes'), function (notes) {
      return R.pipe(R.concat, R.uniq)(notes || [], attributesInLayoutCombination);
    })(customAttributes);
    return R.mapObjIndexed(function (obs) {
      var isAttrCell = R.pathOr('OBS_VAL', ['indexedDimValIds', 'OBS_ATTR'], obs) !== 'OBS_VAL';
      var relevantAttributes = isAttrCell ? [] : getCellRelevantAttributes(obs.attributes, attributesSeries, cellsAttributesId);
      var flagsAndNotes = isAttrCell ? [] : (0, _getFlagsAndNotes.getFlagsAndNotes)(R.omit(attributesInCellsCombination, relevantAttributes), _customAttributes);
      var combinedSeries = isAttrCell ? [] : getCellCombinedSeries(relevantAttributes, combinations.cells || []);
      var hasAdvancedAttributes = isAttrCell ? false : R.pipe(R.omit(R.unnest([_customAttributes.flags || [], _customAttributes.notes || [], attributesInCellsCombination])), R.isEmpty, R.not)(relevantAttributes);
      var hasMetadata = isAttrCell ? false : (0, _hasCellMetadata.hasCellMetadata)(metadataCoordinates, obs.indexedDimValIds);
      return (0, _extends3.default)({}, R.pick(['indexedDimValIds', 'key'], obs), {
        flags: R.concat(flagsAndNotes, combinedSeries),
        sideProps: hasAdvancedAttributes || hasMetadata ? {
          hasAdvancedAttributes: hasAdvancedAttributes,
          hasMetadata: hasMetadata,
          coordinates: obs.indexedDimValIds
        } : null,
        intValue: R.is(Number, obs.value) ? obs.value : null,
        value: obs.formattedValue
      });
    }, observations);
  };
};